const app = {
    'apiUrl' : process.env.VUE_APP_API_BASE,
    'apiHost': process.env.VUE_APP_API_HOST,
    'mapBoxApiKey': process.env.VUE_APP_MAP_BOX_PUBLIC_KEY
}
  
export default app